import { render, staticRenderFns } from "./tradedetail.vue?vue&type=template&id=0d21a912&scoped=true"
import script from "./tradedetail.vue?vue&type=script&lang=js"
export * from "./tradedetail.vue?vue&type=script&lang=js"
import style0 from "./tradedetail.vue?vue&type=style&index=0&id=0d21a912&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d21a912",
  null
  
)

export default component.exports